export enum PageTypes{
  After = 0, // eslint-disable-line no-unused-vars
  From = 1, // eslint-disable-line no-unused-vars
  Before = 2, // eslint-disable-line no-unused-vars
}

export default PageTypes;
